<template>
<!-- <div>
    <v-btn @click="toggleAllSelection" color="primary">All</v-btn> -->
        <v-row>
            <v-col v-for="(item, index) in items" :key="index" cols="12" md="3" class="pa-0">

                <v-card @click="toggleCardSelection(item)" :key="item.assetId" elevation="0" outlined class="asset_card ma-2">
                    <!--이미지 안에 요소-->
                    <div class="image-container">
                        <v-img 
                        :src="getImage(item.image)"
                        style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                        :contain="true"
                        >
                        <v-row>
                            <!--checkbox-->
                            <v-col>
                                <v-checkbox :checked="isChecked(item.assetId)" :value="item.assetId" @click.stop="selCards(item.assetId)" class="ma-3" dark></v-checkbox>   
                            </v-col>

                            <!--인코딩 status & progress-->
                            <v-col class="text-right pa-2">
                                <template v-for="(chip, index) in chips(item.assetId)">

                                    <template v-if="chip.text === 'processing ...'">
                                        <v-progress-circular 
                                            :key="'progress-' + index"
                                            :rotate="180"
                                            :size="30"
                                            :width="3"
                                            :value="chip.percent"
                                            class="ml-1"
                                            color="#fff"
                                            >
                                            <span style="font-size: 10px;color: #fff;">{{ chip.percent }}%</span>
                                        </v-progress-circular>
                                    </template>

                                    <template v-else>
                                        <Chips :key="'chips-' + index" :chipText="chip.text" :ChipsColor="chip.color" class="mr-1"/>
                                    </template>

                                </template>
                            </v-col>
                        </v-row>
                        
                        <!--영상 시간-->
                        <span class="asset_runtime">{{ item.runtime }}</span>
                        <div class="overlay_wrap" v-if="codecCheck(item)" >
                            <v-tooltip bottom  color="#FFF3F3">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="overlay">
                                        <v-icon v-bind="attrs" v-on="on" color="error" style="background: #fff;border-radius: 50%;">mdi-alert-circle</v-icon>
                                    </div>
                                </template>
                                <span style="color: #FF0505;">인코딩 후 영상 재생이 가능합니다.</span>
                            </v-tooltip>
                        </div>
                        </v-img>
                    </div>

                    <!--이미지 하단 요소-->
                    <div class="pa-4">

                        <!--영상 이름-->
                        <h4 class="card-heading pb-1">{{ item.name }}</h4>

                        <!--영상 업로드 날짜-->
                        <span class="asset_uploadtime mr-2 mt-2">{{ item.upload_time }}</span>

                        <!--그룹 리스트-->
                        <template v-if="item.groupData.length <= 1">
                            <span v-for="(group, index) in item.groupData" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                                {{ group }}
                            </span>
                        </template>

                        <template v-else>
                            <span v-for="(group, index) in item.groupData.slice(0, 1)" :key="index" :style="{ backgroundColor: generateColor(group) }" class="asset_group">
                                {{ group }}
                            </span>
                            <span class="asset_group_more">
                                외 {{ item.groupData.length - 0 }}개
                            </span>
                        </template>

                    </div>  

                        

                </v-card>
            </v-col>
        </v-row>
<!-- </div> -->
</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import { mapState } from 'vuex';

export default {
    components: {
        Chips,
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        rowClick: {
            type: Function,
            required: true
        },
    },
    data() {
        return {
            selectedCards: [],
        }
    },
    mounted() {
        
    },
    computed: {
        ...mapState('asset', ['dataLoad']),
        chips() {
            return (id) => {
                if(this.dataLoad && this.tableDatas){
                    return this.getChipData(id);
                }
                else {
                    return null;
                }
            }
        },
        tableDatas(){
           if(this.dataLoad && this.items){
                return this.items;
           }
           return this.items;
        },
    },
    methods: {
        getImage(src){
            if (src && src.trim() !== "") {
                return src;
            } else {
                return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
            }
        },
        codecCheck(item){
            if(item.upload_v_codec !== 'h264' && (item.status === 'uploaded' || item.status === 'processing')){
                return true;
            } else if((item.status === 'h264' || item.status !== 'h264') && item.status.includes('encoded')){
                return false;
            }
        },
        generateColor(group) {
            const hashCode = s => {
                let h = 0;
                for (let i = 0; i < s.length; i++) {
                    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
                }
                return h;
            };
            const color = "#" + ((hashCode(group) & 0xFFFFFF) << 0).toString(16);
            return color;
        },
        getChipData(id) {
            const result = [];

            const data = this.tableDatas.map(e => e.encodingInfo).flat();
            const filtered = data.filter(e => e.origin_asset_id === id);

            const typeDatas = {};
            filtered.forEach(e => {
                const type = e.type;
                const text = e.status === 'processing ...' ? 'processing ...' : this.updateType(e.type);
                const status = e.status;
                const percent = status === 'processing ...' ? (e.percent || 0) : null;

                typeDatas[type] = {
                    text: text,
                    color: status === 'encoded' ? 'black' : '!black',
                    percent: percent
                };
            });

            for (const type in typeDatas) {
                result.push(typeDatas[type]);
            }

            return result;
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        toggleCardSelection(item) {
            this.rowClick(item);
        },
        selCards(id) {
            if (this.isChecked(id)) {
                this.selectedCards = this.selectedCards.filter(e => e !== id);
            } else {
                this.selectedCards.push(id);
            }
            console.log("선택 체크박스 => ", this.selectedCards)
        },
        isChecked(id){
            return this.selectedCards.includes(id);
        },
        // toggleAllSelection() {
        //     if (this.selectedCards.length === this.items.length) {
        //         this.selectedCards = [];
        //     } else {
        //         this.selectedCards = this.items.map(e => e.assetId);
        //         console.log(this.selectedCards)
        //     }
        // }
    }
}
</script>

<style scoped>
.image-container{
    background-color: black;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    width:100%;
    overflow: hidden;
}
.overlay_wrap{
    width: 100%;
    height: 100%;
    background: rgba(255, 74, 74, 0.4);
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
 
 border-radius: 50%;
  transform: translate(-50%, -50%);
}

.overlay v-icon {
  font-size: 48px;
  color: white;
  cursor: pointer;
}
.asset_card{
    border-radius: 12px;
}
.asset_runtime{
    position: absolute;
    bottom: 10px;
    right:10px;
    background: rgba(0, 0, 0, 0.5);
    color:#fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
}
.asset_group {
    color: #fff;
    background: rgba(141, 141, 141, 0.6);
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 4px;
    font-size: 12px;
}
.asset_group_more{
    color: #aaa;
    font-size: 12px;
}
.card-heading {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.asset_uploadtime{
    font-size: 14px;
    color:#999
}
</style>
